import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { morphologicCodeConfigurationServices } from '@/api/resources/configuration/samples/morphologicCode/morphologicCodeConfigurationServices'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'

export const columnsDefMorphologicCodeGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            width: 150,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.morphology'),
            field: 'description',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        // {
        //     type: AgGridColumnType.CHECK_ICON,
        //     headerName: i18n.tc('configuration.grid.ownCode'),
        //     field: 'ownCode',
        //     minWidth: 150,
        //     suppressSizeToFit: true
        // },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 150,
            suppressSizeToFit: true
        }
    ]

export interface IContentMorphologicCodeGrid {
    id?: number
    code: string
    description: string
    active: boolean
}
export const initialMorphologicCodeModalState =
    (): IContentMorphologicCodeGrid => ({
        id: undefined,
        code: '',
        description: '',
        active: false
    })

export type IMorphologicCodeGridState = CrudModelBase<IContentMorphologicCodeGrid>
export const initialMorphologicCodeGridState =
    (): IMorphologicCodeGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.samples.morphology',
        columnsDef: columnsDefMorphologicCodeGrid(),
        datasource: new PaginatorDatasource(morphologicCodeConfigurationServices)
    })
